import { useToast } from 'primevue/usetoast';

/**
 * Composable that returns a function for showing follow/unfollow toast
 * notifications to the user.
 *
 * @returns {Function} A `(severity, type, followerName, negative) => void` function that displays the appropriate toast
 */
export function useFollowNotification() {
  const toast = useToast();

  /**
   * Shows a success or error toast for a follow/unfollow action.
   *
   * @param {'success'|'error'} severity - Whether the action succeeded or failed
   * @param {'followed'|'unfollowed'} type - Which action was performed
   * @param {string} followerName - The name of the user being followed/unfollowed (currently unused in the message text)
   * @param {boolean} negative - Whether the follow is a "skeptic" style follow (currently unused in the message text)
   * @returns {void}
   */
  return (severity, type, followerName, negative) => {
    let detailMessage = '';

    if (severity === 'success') {
      if (type === 'followed') {
        // detailMessage = `You have successfully followed this user ${
        //   negative ? 'skeptically' : 'as a fan'
        // }. Their posts will now appear in your For you (${negative ? 'skeptic' : 'fan'}) feed.`;
        detailMessage = `You are following this user. Their posts will appear in your "Who I Follow" feed`;
      } else if (type === 'unfollowed') {
        // detailMessage = `You have successfully unfollowed this user ${
        //   negative ? 'as a skeptical follower' : 'as a fan'
        // }. You will no longer see their posts in your For you (${negative ? 'skeptic' : 'fan'}) feed.`;
        detailMessage = `You will no longer see their posts in your "Who I Follow" feed`;
      }
    } else {
      if (type === 'followed') {
        // detailMessage = `An error occurred while trying to follow this user ${
        //   negative ? 'as a skeptical follower' : 'as a fan'
        // }. Please try again later.`;
        detailMessage = `An error occurred while trying to follow this user. Please try again later.`;
      } else if (type === 'unfollowed') {
        // detailMessage = `An error occurred while trying to unfollow this user ${
        //   negative ? 'as a skeptical follower' : 'as a fan'
        // }. Please try again later.`;
        detailMessage = `An error occurred while trying to unfollow this user. Please try again later.`;
      }
    }

    toast.add({
      severity: severity,
      summary: severity === 'success' ? 'Success' : 'Error',
      detail: detailMessage,
      life: 5000,
    });
  };
}
